export default {
  page: 'trang',
  system: 'quản lý hệ thống',
  userAdmin: 'quản lý tài khoản',
  userList: 'danh sách tài khoản',
  userName: ' tên tài khoản',
  userPass: 'mật khẩu',
  email: 'email',
  userPhone: 'số điện thoại',
  userType: 'loại tài khoản',
  selectuserType: 'chọn loại tài khoản',
  createAcct: ' người cập nhật',
  makeupAmountLimit: 'Số dư khả dụng cho các đơn đặt hàng bổ sung',
  createTime: 'thời gian cập nhật',
  userState: 'trạng thái tài khoản',
  operation: 'thao tác',
  addUser: 'thêm tài khoản',
  inputtext: 'vui lòng nhập tiền',
  inactive: ' vô hiệu hóa',
  active: ' kích hoạt',
  cancel: '  hủy bỏ',
  confirm: ' xác nhận',
  changePass: 'thay đổi mật khẩu',
  selectbank: 'Vui lòng chọn ngân hàng',

  checkKey: 'Xem khóa',
  resetPass: 'Đặt lại mật khẩu thanh toán',
  resetSignPass: 'Đặt lại mật khẩu đăng nhập',
  oblPass: 'mật khẩu cũ',
  newPass: 'mật khẩu mới',
  roleName: 'vai trò',
  addFormName: 'mời nhập tên người dùng , tên người dùng không được để trống',
  addFormPass: 'vui lòng nhập mật khẩu, mật khẩu không được để trống',
  addFormId: 'vui lòng nhập ID',
  addFormType: 'vui lòng nhập loại tài khoản',
  addFormPhone: 'vui lòng nhập số điện thoại, số điện thoại không được để trống',
  addFormEmail: 'vui lòng nhập email, email không được để trống',
  Administrator: 'quản trị viên',
  Agency: 'đại lý',
  Commercial: 'merchant',
  addrefError: 'tham số không hợp lệ',
  changerefError: 'tham số không hợp lệ hoặc mật khẩu mới giống mật khẩu cũ',
  checkPassErr: 'vui lòng nhập mã xác nhận,  bao gồm 6-25 kí tự',
  checkNameErr: 'tên người dùng hợp lệ từ 4-20 kí tự bao gồm cả số và chữ',
  checkEmailErr: 'vui lòng nhập email hợp lệ , ví dụ : wangyi@163.com',
  checkPhoneErr: 'vui lòng nhập số điện thoại hợp lệ , ví dụ :0-3(5,7,8,9)-00000000',
  hintmessage: ' bạn cần đặt lại mật khẩu ?',
  electwellattype: 'chọn loại ví',
  refreshCacheHint: 'Có nên làm mới bộ nhớ đệm không'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/accountmanager.js